// extracted by mini-css-extract-plugin
module.exports = {"app-shell":"_2Wk06m-AppShell-app-shell","appShell":"_2Wk06m-AppShell-app-shell"};